module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "4"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n            ")], 1)], 1), _vm._v(" "), _c('h5', {
    staticClass: "mt-1 mr-2"
  }, [_vm._v("\n            " + _vm._s(_vm.$route.name) + "\n          ")])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h5', [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalData) + " Entries")]) : _vm._e()])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    class: ' ml-4' + _vm.visible ? null : 'collapsed',
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": _vm.Filter.BRFNoFilter ||
        _vm.Filter.enqNoFilter ||
        _vm.Filter.vesselNameFilter ||
        _vm.Filter.vesselVoyageFilter ||
        _vm.Filter.vesselSailDateFilter ||
        _vm.Filter.fk_contract_id ||
        _vm.Filter.fk_ccbm_id ||
        _vm.Filter.contractNoFilter ||
        _vm.Filter.serach_txt ||
        _vm.Filter.slineFilter ||
        _vm.Filter.clientFilter ||
        _vm.Filter.createdByFilter ||
        _vm.Filter.dateRange.startDate ||
        _vm.Filter.dateRange.endDate ?
        'outline-danger' :
        'outline-primary',
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v(_vm._s(_vm.Filter.BRFNoFilter ||
    _vm.Filter.enqNoFilter ||
    _vm.Filter.vesselNameFilter ||
    _vm.Filter.vesselVoyageFilter ||
    _vm.Filter.vesselSailDateFilter ||
    _vm.Filter.fk_contract_id ||
    _vm.Filter.fk_ccbm_id ||
    _vm.Filter.contractNoFilter ||
    _vm.Filter.serach_txt ||
    _vm.Filter.slineFilter ||
    _vm.Filter.clientFilter ||
    _vm.Filter.createdByFilter ||
    _vm.Filter.dateRange.startDate ||
    _vm.Filter.dateRange.endDate ?
    "Filter ON" :
    "Filter OFF"))]), _vm._v(" "), (_vm.getBookingResp.length > 0) ? _c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('getBookingResp', 'Export As Excel')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.ExcelBtnName) + "\n            "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  })], 1), _vm._v(" "), (_vm.visible) ? _c('div', [_c('b-card', [_c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale,
      "disabled": _vm.Filter.DFlag ? true : false
    },
    on: {
      "update": function($event) {
        _vm.getBookingRespDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "dateRange", $$v)
      },
      expression: "Filter.dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("BRF NO Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search BRF NO Filter",
      "id": "BRFNoFilter",
      "name": "BRFNoFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getBookingRespDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.BRFNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "BRFNoFilter", $$v)
      },
      expression: "Filter.BRFNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Enq NO Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Enq NO Filter",
      "id": "enqNoFilter",
      "name": "enqNoFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getBookingRespDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.enqNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "enqNoFilter", $$v)
      },
      expression: "Filter.enqNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Vessel Name Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Vessel Name Filter",
      "id": "vesselNameFilter",
      "name": "vesselNameFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getBookingRespDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.vesselNameFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "vesselNameFilter", $$v)
      },
      expression: "Filter.vesselNameFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Voyage No Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Voyage No Filter",
      "id": "vesselVoyageFilter",
      "name": "vesselVoyageFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getBookingRespDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.vesselVoyageFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "vesselVoyageFilter", $$v)
      },
      expression: "Filter.vesselVoyageFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Vessel Sail Date Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "date",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Vessel Sail Date Filter",
      "id": "vesselSailDateFilter",
      "name": "vesselSailDateFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getBookingRespDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.vesselSailDateFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "vesselSailDateFilter", $$v)
      },
      expression: "Filter.vesselSailDateFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Contract No")]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-1",
    attrs: {
      "list": _vm.$store.getters['common/getAllContractList'],
      "id": "fk_contract_id",
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select Contract NUMBER"
    },
    on: {
      "input": function($event) {
        _vm.getContractNoBasedVessel(_vm.Filter.fk_contract_id);
        _vm.getBrfAnalysisList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.fk_contract_id),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "fk_contract_id", $$v)
      },
      expression: "Filter.fk_contract_id"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Vessel Name :")]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-1",
    attrs: {
      "list": _vm.$store.getters['common/getAllContractBasedVesselList'],
      "id": "vessel_name",
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select Vessel Name"
    },
    on: {
      "input": function($event) {
        _vm.getBookingRespDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.fk_ccbm_id),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "fk_ccbm_id", $$v)
      },
      expression: "Filter.fk_ccbm_id"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Shipping Line")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllShippingLineList'],
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    on: {
      "input": function($event) {
        _vm.getBookingRespDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.slineFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "slineFilter", $$v)
      },
      expression: "Filter.slineFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Client")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "id": "clientFilter",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client Name"
    },
    on: {
      "input": function($event) {
        _vm.getBookingRespDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.clientFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "clientFilter", $$v)
      },
      expression: "Filter.clientFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Common Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Common Filter",
      "id": "serach_txt",
      "name": "serach_txt",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getBookingRespDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.serach_txt),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "serach_txt", $$v)
      },
      expression: "Filter.serach_txt"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v(" Created User ")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "createdByFilter",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Created User"
    },
    on: {
      "input": function($event) {
        _vm.getBookingRespDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.createdByFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "createdByFilter", $$v)
      },
      expression: "Filter.createdByFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "ml-1 pull-right",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCheckAll),
      expression: "isCheckAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isCheckAll) ? _vm._i(_vm.isCheckAll, null) > -1 : (_vm.isCheckAll)
    },
    on: {
      "click": function($event) {
        _vm.SelectAll(_vm.getBookingResp)
      },
      "change": function($event) {
        var $$a = _vm.isCheckAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isCheckAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isCheckAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isCheckAll = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Select / Deselect All Count(" + _vm._s(this.brcm_ids.length) + ")")]), _vm._v(" "), (_vm.brcm_ids.length > 0) ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.ProceedMultiBRFRate
    }
  }, [_vm._v("Multi\n            Update")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive tableMain gutr"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "items": _vm.getBookingResp,
      "fields": _vm.BookingEditorFields,
      "primary-key": "id_email_section",
      "per-page": _vm.pagination.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.brcm_ids),
            expression: "brcm_ids"
          }],
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "value": row0.item.brcm_id,
            "checked": Array.isArray(_vm.brcm_ids) ? _vm._i(_vm.brcm_ids, row0.item.brcm_id) > -1 : (_vm.brcm_ids)
          },
          on: {
            "change": [function($event) {
              var $$a = _vm.brcm_ids,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = row0.item.brcm_id,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.brcm_ids = $$a.concat([$$v]))
                } else {
                  $$i > -1 && (_vm.brcm_ids = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.brcm_ids = $$c
              }
            }, function($event) {
              _vm.updateSelectAll($event, row0.item)
            }]
          }
        }), _vm._v(" "), _c('span', [_vm._v("\n                  " + _vm._s(row0.index + 1 + (_vm.pagination.currentPage - 1) * _vm.pagination.perPage) + "\n                ")])]
      }
    }, {
      key: "BrfNo",
      fn: function(row1) {
        return [(row1.item.BrfNo) ? _c('span', [_vm._v("BRF No : " + _vm._s(row1.item.BrfNo)), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.isEditing) ? _c('b-form-input', {
          staticClass: "w-100",
          nativeOn: {
            "keydown": function($event) {
              $event.stopPropagation();
            }
          },
          model: {
            value: (_vm.editingRowData.brcm_rate),
            callback: function($$v) {
              _vm.$set(_vm.editingRowData, "brcm_rate", $$v)
            },
            expression: "editingRowData.brcm_rate"
          }
        }) : _c('span', [_vm._v(_vm._s(row1.item.brcm_rate))])]
      }
    }, {
      key: "Client",
      fn: function(row1) {
        return [(row1.item.Client) ? _c('span', [_vm._v("Shipper : " + _vm._s(row1.item.Client)), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.isEditing) ? _c('b-form-input', {
          staticClass: "w-100",
          nativeOn: {
            "keydown": function($event) {
              $event.stopPropagation();
            }
          },
          model: {
            value: (_vm.editingRowData.brcm_sell_rate),
            callback: function($$v) {
              _vm.$set(_vm.editingRowData, "brcm_sell_rate", $$v)
            },
            expression: "editingRowData.brcm_sell_rate"
          }
        }) : _c('span', [_vm._v(_vm._s(row1.item.brcm_sell_rate))])]
      }
    }, {
      key: "Sline",
      fn: function(row1) {
        return [(row1.item.Sline) ? _c('span', [_vm._v("Sline : " + _vm._s(row1.item.Sline)), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "d-flex"
        }, [_c('b-button', {
          staticClass: "mr-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-primary"
          },
          on: {
            "click": function($event) {
              _vm.getBRFPricingLog(row1.item)
            }
          }
        }, [_vm._v("\n                    Log\n                  ")]), _vm._v(" "), _c('b-button', {
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-primary"
          },
          on: {
            "click": function($event) {
              _vm.startEditing(row1.item)
            }
          }
        }, [_vm._v("\n                    Edit\n                  ")]), _vm._v(" "), (row1.item.isEditing) ? _c('b-button', {
          staticClass: "ml-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "success"
          },
          on: {
            "click": function($event) {
              _vm.saveRow(row1.item)
            }
          }
        }, [_vm._v("\n                    Save\n                  ")]) : _vm._e(), _vm._v(" "), (row1.item.isEditing) ? _c('b-button', {
          staticClass: "ml-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "danger"
          },
          on: {
            "click": function($event) {
              _vm.cancelEdit(row1.item)
            }
          }
        }, [_vm._v("\n                    Cancel\n                  ")]) : _vm._e()], 1)]
      }
    }, {
      key: "action",
      fn: function(row1) {
        return [(row1.item.pricing_booking_resp_map_relation.prbr_id > 0 && row1.item.console_booking_response_relation.booking_id > 0) ? _c('ToggleBRFSwitch', {
          attrs: {
            "brf_no": row1.item.pricing_booking_resp_map_relation.enquiry_booking_no,
            "booking_no": row1.item.console_booking_response_relation.booking_no,
            "booking_id": row1.item.console_booking_response_relation.booking_id,
            "prbr_id": row1.item.pricing_booking_resp_map_relation.prbr_id,
            "isbookingactive": row1.item.console_booking_response_relation.isbookingactive,
            "prbr_is_active": row1.item.pricing_booking_resp_map_relation.prbr_is_active,
            "request_type": 'BRFEditor'
          },
          on: {
            "success": _vm.getBookingRespDash
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.fk_prbr_id > 0) ? _c('BRFCard', {
          attrs: {
            "BRFDetails": row1.item,
            "prbr_id": Number(row1.item.fk_prbr_id)
          }
        }) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)])])], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "viewBRFDetails-modal",
    attrs: {
      "id": "viewBRFDetails-modal",
      "title": 'BRF Rate Log Details-' + _vm.BRFNo,
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-table', {
    attrs: {
      "items": _vm.BrfBookingList,
      "fields": _vm.BrfBookingColumn,
      "small": "",
      "responsive": "",
      "head-variant": "light"
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.item.SN))])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right btn-sm mt-2",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.hideviewBRFDetails
    }
  }, [_vm._v("\n      Close")])], 1), _vm._v(" "), _c('b-modal', {
    ref: "Multi-BRF-Modal",
    attrs: {
      "id": "Multi-BRF-Modal",
      "title": "Multi BRF Rate Editor",
      "centered": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('label', [_vm._v("\n          Buy Rate\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "brcm_rate",
      "id": "brcm_rate",
      "type": "text"
    },
    model: {
      value: (_vm.MultiBRF.brcm_rate),
      callback: function($$v) {
        _vm.$set(_vm.MultiBRF, "brcm_rate", $$v)
      },
      expression: "MultiBRF.brcm_rate"
    }
  }), _vm._v(" "), (!_vm.MultiBRF.brcm_rate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorMultiBRF.brcm_rate) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('label', [_vm._v("\n          Sell Rate\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "brcm_sell_rate",
      "id": "brcm_sell_rate",
      "type": "text"
    },
    model: {
      value: (_vm.MultiBRF.brcm_sell_rate),
      callback: function($$v) {
        _vm.$set(_vm.MultiBRF, "brcm_sell_rate", $$v)
      },
      expression: "MultiBRF.brcm_sell_rate"
    }
  }), _vm._v(" "), (!_vm.MultiBRF.brcm_sell_rate ? true : false) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorMultiBRF.brcm_sell_rate) + "\n        ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2 flex"
  }, [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-button', {
    staticClass: "sm",
    attrs: {
      "disabled": ((_vm.MultiBRF.brcm_rate || _vm.MultiBRF.brcm_sell_rate) && _vm.brcm_ids.length > 0) ? false : true,
      "variant": "success"
    },
    on: {
      "click": _vm.PayMultiBRF
    }
  }, [_vm._v("Proceed")]), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right sm",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.closeMultiBRFModal
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0842bcdc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/Pricing/bookingRespDashEdit.vue
// module id = 2373
// module chunks = 0